export default template;
function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (content) {
      pug_html = pug_html + "\u003Cdiv class=\"app\"\u003E\u003Cmain class=\"app-content\"\u003E\u003Cdiv\u003E" + (null == (pug_interp = content) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fmain\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "content" in locals_for_with ?
        locals_for_with.content :
        typeof content !== 'undefined' ? content : undefined));
    ;;return pug_html;}